/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LoginImport } from './routes/login'
import { Route as AgbImport } from './routes/agb'
import { Route as AuthenticatedImport } from './routes/_authenticated'
import { Route as IndexImport } from './routes/index'
import { Route as AuthSetPasswordImport } from './routes/auth/set-password'
import { Route as AuthForgotPasswordImport } from './routes/auth/forgot-password'
import { Route as AuthenticatedSettingsImport } from './routes/_authenticated/settings'
import { Route as AuthenticatedPlacementsImport } from './routes/_authenticated/placements'
import { Route as AuthenticatedPerformanceImport } from './routes/_authenticated/performance'
import { Route as AuthenticatedOverviewImport } from './routes/_authenticated/overview'
import { Route as AuthenticatedCreatorImport } from './routes/_authenticated/creator'
import { Route as AuthenticatedSettingsIndexImport } from './routes/_authenticated/settings/index'
import { Route as AuthenticatedSettingsTeamImport } from './routes/_authenticated/settings/team'
import { Route as AuthenticatedSettingsProfileImport } from './routes/_authenticated/settings/profile'

// Create/Update Routes

const LoginRoute = LoginImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRoute,
} as any)

const AgbRoute = AgbImport.update({
  id: '/agb',
  path: '/agb',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedRoute = AuthenticatedImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRoute,
} as any)

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any)

const AuthSetPasswordRoute = AuthSetPasswordImport.update({
  id: '/auth/set-password',
  path: '/auth/set-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthForgotPasswordRoute = AuthForgotPasswordImport.update({
  id: '/auth/forgot-password',
  path: '/auth/forgot-password',
  getParentRoute: () => rootRoute,
} as any)

const AuthenticatedSettingsRoute = AuthenticatedSettingsImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedPlacementsRoute = AuthenticatedPlacementsImport.update({
  id: '/placements',
  path: '/placements',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedPerformanceRoute = AuthenticatedPerformanceImport.update({
  id: '/performance',
  path: '/performance',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedOverviewRoute = AuthenticatedOverviewImport.update({
  id: '/overview',
  path: '/overview',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedCreatorRoute = AuthenticatedCreatorImport.update({
  id: '/creator',
  path: '/creator',
  getParentRoute: () => AuthenticatedRoute,
} as any)

const AuthenticatedSettingsIndexRoute = AuthenticatedSettingsIndexImport.update(
  {
    id: '/',
    path: '/',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any,
)

const AuthenticatedSettingsTeamRoute = AuthenticatedSettingsTeamImport.update({
  id: '/team',
  path: '/team',
  getParentRoute: () => AuthenticatedSettingsRoute,
} as any)

const AuthenticatedSettingsProfileRoute =
  AuthenticatedSettingsProfileImport.update({
    id: '/profile',
    path: '/profile',
    getParentRoute: () => AuthenticatedSettingsRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AuthenticatedImport
      parentRoute: typeof rootRoute
    }
    '/agb': {
      id: '/agb'
      path: '/agb'
      fullPath: '/agb'
      preLoaderRoute: typeof AgbImport
      parentRoute: typeof rootRoute
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/creator': {
      id: '/_authenticated/creator'
      path: '/creator'
      fullPath: '/creator'
      preLoaderRoute: typeof AuthenticatedCreatorImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/overview': {
      id: '/_authenticated/overview'
      path: '/overview'
      fullPath: '/overview'
      preLoaderRoute: typeof AuthenticatedOverviewImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/performance': {
      id: '/_authenticated/performance'
      path: '/performance'
      fullPath: '/performance'
      preLoaderRoute: typeof AuthenticatedPerformanceImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/placements': {
      id: '/_authenticated/placements'
      path: '/placements'
      fullPath: '/placements'
      preLoaderRoute: typeof AuthenticatedPlacementsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/_authenticated/settings': {
      id: '/_authenticated/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof AuthenticatedSettingsImport
      parentRoute: typeof AuthenticatedImport
    }
    '/auth/forgot-password': {
      id: '/auth/forgot-password'
      path: '/auth/forgot-password'
      fullPath: '/auth/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordImport
      parentRoute: typeof rootRoute
    }
    '/auth/set-password': {
      id: '/auth/set-password'
      path: '/auth/set-password'
      fullPath: '/auth/set-password'
      preLoaderRoute: typeof AuthSetPasswordImport
      parentRoute: typeof rootRoute
    }
    '/_authenticated/settings/profile': {
      id: '/_authenticated/settings/profile'
      path: '/profile'
      fullPath: '/settings/profile'
      preLoaderRoute: typeof AuthenticatedSettingsProfileImport
      parentRoute: typeof AuthenticatedSettingsImport
    }
    '/_authenticated/settings/team': {
      id: '/_authenticated/settings/team'
      path: '/team'
      fullPath: '/settings/team'
      preLoaderRoute: typeof AuthenticatedSettingsTeamImport
      parentRoute: typeof AuthenticatedSettingsImport
    }
    '/_authenticated/settings/': {
      id: '/_authenticated/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof AuthenticatedSettingsIndexImport
      parentRoute: typeof AuthenticatedSettingsImport
    }
  }
}

// Create and export the route tree

interface AuthenticatedSettingsRouteChildren {
  AuthenticatedSettingsProfileRoute: typeof AuthenticatedSettingsProfileRoute
  AuthenticatedSettingsTeamRoute: typeof AuthenticatedSettingsTeamRoute
  AuthenticatedSettingsIndexRoute: typeof AuthenticatedSettingsIndexRoute
}

const AuthenticatedSettingsRouteChildren: AuthenticatedSettingsRouteChildren = {
  AuthenticatedSettingsProfileRoute: AuthenticatedSettingsProfileRoute,
  AuthenticatedSettingsTeamRoute: AuthenticatedSettingsTeamRoute,
  AuthenticatedSettingsIndexRoute: AuthenticatedSettingsIndexRoute,
}

const AuthenticatedSettingsRouteWithChildren =
  AuthenticatedSettingsRoute._addFileChildren(
    AuthenticatedSettingsRouteChildren,
  )

interface AuthenticatedRouteChildren {
  AuthenticatedCreatorRoute: typeof AuthenticatedCreatorRoute
  AuthenticatedOverviewRoute: typeof AuthenticatedOverviewRoute
  AuthenticatedPerformanceRoute: typeof AuthenticatedPerformanceRoute
  AuthenticatedPlacementsRoute: typeof AuthenticatedPlacementsRoute
  AuthenticatedSettingsRoute: typeof AuthenticatedSettingsRouteWithChildren
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedCreatorRoute: AuthenticatedCreatorRoute,
  AuthenticatedOverviewRoute: AuthenticatedOverviewRoute,
  AuthenticatedPerformanceRoute: AuthenticatedPerformanceRoute,
  AuthenticatedPlacementsRoute: AuthenticatedPlacementsRoute,
  AuthenticatedSettingsRoute: AuthenticatedSettingsRouteWithChildren,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '': typeof AuthenticatedRouteWithChildren
  '/agb': typeof AgbRoute
  '/login': typeof LoginRoute
  '/creator': typeof AuthenticatedCreatorRoute
  '/overview': typeof AuthenticatedOverviewRoute
  '/performance': typeof AuthenticatedPerformanceRoute
  '/placements': typeof AuthenticatedPlacementsRoute
  '/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/set-password': typeof AuthSetPasswordRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/settings/': typeof AuthenticatedSettingsIndexRoute
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '': typeof AuthenticatedRouteWithChildren
  '/agb': typeof AgbRoute
  '/login': typeof LoginRoute
  '/creator': typeof AuthenticatedCreatorRoute
  '/overview': typeof AuthenticatedOverviewRoute
  '/performance': typeof AuthenticatedPerformanceRoute
  '/placements': typeof AuthenticatedPlacementsRoute
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/set-password': typeof AuthSetPasswordRoute
  '/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/settings': typeof AuthenticatedSettingsIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/': typeof IndexRoute
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/agb': typeof AgbRoute
  '/login': typeof LoginRoute
  '/_authenticated/creator': typeof AuthenticatedCreatorRoute
  '/_authenticated/overview': typeof AuthenticatedOverviewRoute
  '/_authenticated/performance': typeof AuthenticatedPerformanceRoute
  '/_authenticated/placements': typeof AuthenticatedPlacementsRoute
  '/_authenticated/settings': typeof AuthenticatedSettingsRouteWithChildren
  '/auth/forgot-password': typeof AuthForgotPasswordRoute
  '/auth/set-password': typeof AuthSetPasswordRoute
  '/_authenticated/settings/profile': typeof AuthenticatedSettingsProfileRoute
  '/_authenticated/settings/team': typeof AuthenticatedSettingsTeamRoute
  '/_authenticated/settings/': typeof AuthenticatedSettingsIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | ''
    | '/agb'
    | '/login'
    | '/creator'
    | '/overview'
    | '/performance'
    | '/placements'
    | '/settings'
    | '/auth/forgot-password'
    | '/auth/set-password'
    | '/settings/profile'
    | '/settings/team'
    | '/settings/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | ''
    | '/agb'
    | '/login'
    | '/creator'
    | '/overview'
    | '/performance'
    | '/placements'
    | '/auth/forgot-password'
    | '/auth/set-password'
    | '/settings/profile'
    | '/settings/team'
    | '/settings'
  id:
    | '__root__'
    | '/'
    | '/_authenticated'
    | '/agb'
    | '/login'
    | '/_authenticated/creator'
    | '/_authenticated/overview'
    | '/_authenticated/performance'
    | '/_authenticated/placements'
    | '/_authenticated/settings'
    | '/auth/forgot-password'
    | '/auth/set-password'
    | '/_authenticated/settings/profile'
    | '/_authenticated/settings/team'
    | '/_authenticated/settings/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  AgbRoute: typeof AgbRoute
  LoginRoute: typeof LoginRoute
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthSetPasswordRoute: typeof AuthSetPasswordRoute
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  AgbRoute: AgbRoute,
  LoginRoute: LoginRoute,
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthSetPasswordRoute: AuthSetPasswordRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/agb",
        "/login",
        "/auth/forgot-password",
        "/auth/set-password"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/creator",
        "/_authenticated/overview",
        "/_authenticated/performance",
        "/_authenticated/placements",
        "/_authenticated/settings"
      ]
    },
    "/agb": {
      "filePath": "agb.tsx"
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/_authenticated/creator": {
      "filePath": "_authenticated/creator.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/overview": {
      "filePath": "_authenticated/overview.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/performance": {
      "filePath": "_authenticated/performance.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/placements": {
      "filePath": "_authenticated/placements.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/settings": {
      "filePath": "_authenticated/settings.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/settings/profile",
        "/_authenticated/settings/team",
        "/_authenticated/settings/"
      ]
    },
    "/auth/forgot-password": {
      "filePath": "auth/forgot-password.tsx"
    },
    "/auth/set-password": {
      "filePath": "auth/set-password.tsx"
    },
    "/_authenticated/settings/profile": {
      "filePath": "_authenticated/settings/profile.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/team": {
      "filePath": "_authenticated/settings/team.tsx",
      "parent": "/_authenticated/settings"
    },
    "/_authenticated/settings/": {
      "filePath": "_authenticated/settings/index.tsx",
      "parent": "/_authenticated/settings"
    }
  }
}
ROUTE_MANIFEST_END */
